import { combineReducers } from 'redux-immutable'
import compensateRequestCreateReducer from './compensate-request-create-reducer'
import compensateRequestGetReducer from './compensate-request-get-reducer'
import compensateRequestPreviewReducer from './compensate-request-preview-reducer'
import compensateRequestApproveReducer from './compensate-request-approve-reducer'
import compensateRequestCancelReducer from './compensate-request-cancel-reducer'

export default combineReducers({
  compensateRequestCreate: compensateRequestCreateReducer,
  compensateRequestGet: compensateRequestGetReducer,
  compensateRequestPreview: compensateRequestPreviewReducer,
  compensateRequestApprove: compensateRequestApproveReducer,
  compensateRequestCancel: compensateRequestCancelReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/compensate-request/index.js